import { Alert, Box, Button } from "@mui/material";
import PageTitle from "../components/pageTitle";
import PageLayout from "./PageLayout";
import { useNavigate } from "react-router-dom";

const AccessDeniedPage = () => {
  const navigate = useNavigate();

  return (
    <PageLayout>
      <PageTitle title="Access Denied" />
      <Box sx={{ textAlign: "center", mt: 4 }}>
        <Alert severity="error" sx={{ mb: 3 }}>
          You don’t have permission to perform this operation.
        </Alert>
        <Button
          variant="contained"
          onClick={() => navigate(-1)}
          sx={{ mr: 2 }}
        >
          Back
        </Button>
        <Button variant="outlined" onClick={() => navigate("/")}>
          Go to Dashboard
        </Button>
      </Box>
    </PageLayout>
  );
};

export default AccessDeniedPage;
